import { useRaffles } from '@/app/hooks/useRaffles'
import { Separator } from '@/view/components/ui/separator'
import ActiveRaffles from './components/ActiveRaffles'
import LastRaffles from './components/LastRaffles'
import { startOfToday } from 'date-fns'

export const Raffles = () => {
  const endDate = startOfToday()
  const { data, isLoading } = useRaffles({
    search: '',
    skip: 0,
    limit: 3,
    isActive: true,
    endDate,
  })
  const activeRaffles = data?.prizeDraws

  const { data: lastRafflesData, isLoading: lastRafflesLoading } = useRaffles({
    search: '',
    skip: 0,
    limit: 10,
    isActive: false,
    endDate,
  })

  const lastRaffles = lastRafflesData?.prizeDraws

  return (
    <div className="flex w-full max-w-full flex-col gap-6 pb-5 sm:gap-8">
      <h1 className="text-2xl font-semibold sm:text-3xl lg:text-[32px]">
        Sorteios ativos
      </h1>
      <ActiveRaffles raffles={activeRaffles} isLoading={isLoading} />
      <Separator />
      <h1 className="text-2xl font-semibold sm:text-3xl lg:text-[32px]">
        Últimos sorteios
      </h1>
      <LastRaffles raffles={lastRaffles} isLoading={lastRafflesLoading} />
      {/* <RaffleModal /> */}
    </div>
  )
}
